import { Tab } from '@octane/spark';
import React from 'react';

const TermLength = ({
  terms = [],
  preselectedTerm,
  onTermSelect,
}) => {
  if (!terms || terms.length === 0) {
    return null;
  }

  const items = terms.map(term => {
    return {
      label: `${term} months`,
      value: term.toString(),
    };
  });

  const handleOnChange = (value) => {
    onTermSelect(parseInt(value));
  };

  return (
    <Tab
      items={items}
      label="Term Length"
      onChange={handleOnChange}
      initialValue={preselectedTerm}
    />
  );
};

export default TermLength;

